import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/shared/components'
import { FAQPage } from '@/pages/faq/FAQPage'

export const Route = createFileRoute('/faq')({
  component: () => (
    <RequirePermission section="faq" action="view">
      <FAQPage />
    </RequirePermission>
  ),
})
